const ROUTES = {
    ROOT: "/",
    LOGIN: "/login",
    DASHBOARD: "/dashboard",
    EMPLOYEES: "/employees/list",
    EMPLOYEE: (personId) =>
        personId ? `/employee/${personId}` : "/employee/:personId",
    EMPLOYEES_NEW: "/employees/new",
    MY_PROFILE: "/employees/my-profile",
    EMPLOYEES_PERSONAL_DATA_SHEET: "/employees/personal-data-sheet",
    EMPLOYEES_PERSONAL_INFORMATION:
        "/employees/personal-data-sheet/personal-information",
    EMPLOYEES_FAMILY_BACKGROUND:
        "/employees/personal-data-sheet/family-background",
    EMPLOYEES_EDUCATIONAL_BACKGROUND:
        "/employees/personal-data-sheet/educational-background",

    ORGANIZATION: "/organization",

    ATTENDANCE: "/attendance",
    ATTENDANCE_DOWNLOAD_DTR: "/attendance/download-dtr",
    ATTENDANCE_DTR: "/attendance/dtr",
    ATTENDANCE_ALTERNATIVE_WORK: "/attendance/alternative-work",
    ATTENDANCE_SERVICE_RECORD: "/attendance/service-record",
    ATTENDANCE_LEARNING_TRAINING: "/attendance/learning-training",
    ATTENDANCE_LEAVE_MANAGEMENT: "/attendance/leave-management",
    ATTENDANCE_MONITORING: "/attendance/monitoring",

    MAINTENANCE: "/maintenance",
    MAINTENANCE_CODE_REFERENCE: "/maintenance/code-reference",
    MAINTENANCE_AGENCY_INFORMATION: "/maintenance/agency-information",
    MAINTENANCE_DEPARTMENT: "/maintenance/department",
    MAINTENANCE_POSITION: "/maintenance/position",
    MAINTENANCE_LOAN_TYPE: "/maintenance/loan-type",
    MAINTENANCE_LEAVE_TYPE: "/maintenance/leave-type",
    MAINTENANCE_TRAINING: "/maintenance/training",
    MAINTENANCE_HOLIDAYS: "/maintenance/holidays",
    MAINTENANCE_SIGNATORIES: "/maintenance/signatories",
    MAINTENANCE_PAYROLL_PERIOD: "/maintenance/payroll-period",
    MAINTENANCE_USER_MAINTENANCE: "/maintenance/user-maintenance",
    MAINTENANCE_USER_GROUP: "/maintenance/user-maintenance/user-group",
    MAINTENANCE_USERS: "/maintenance/user-maintenance/users",
    MAINTENANCE_USERS_CHANGE_PASSWORD:
        "/maintenance/user-maintenance/users/change-password",
    MAINTENANCE_EMPLOYMENT_STATUS: "/maintenance/employment-status",
    MAINTENANCE_EMPLOYEE_PAY_CLASS: "/maintenance/employee-pay-class",
    MAINTENANCE_TAX_SCHEDULE: "/maintenance/tax-schedule",

    PAYROLL: "/payroll",
    PAYROLL_PROCESSING: "/payroll/processing",
    PAYROLL_ADJUSTMENTS: "/payroll/adjustments",

    REPORTS: "/reports",
    REPORTS_EMPLOYEES: "/reports/employees",
    REPORTS_PERSONNEL_DATA_SHEET: "/reports/personnel-data-sheet",
    PHOTO_CONTAINER: "files/photos",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password/:token"
};

export default ROUTES;
